var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.917,11.25H7.583a.334.334,0,0,0-.3.187.319.319,0,0,0,.046.346L16.139,22.1v6.822a.325.325,0,0,0,.206.3.339.339,0,0,0,.363-.071l3.556-3.47a.322.322,0,0,0,.1-.23V22.1l8.812-10.319a.319.319,0,0,0,.046-.346A.334.334,0,0,0,28.917,11.25Z",
    transform: "translate(-7.25 -11.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.e4b028801a33ff69b8773f03db77aee3.svg";
export { ForwardRef as ReactComponent };